var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgRage = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 73 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.342 5.113a4 4 0 1 0-7.684-2.224L41.75 47.501h-10.08l-9.764-44.36a4 4 0 1 0-7.813 1.72l9.386 42.64H4a4 4 0 0 0 0 8h21.24l6.354 28.86a4 4 0 0 0 7.748.252L47.765 55.5H69a4 4 0 1 0 0-8H50.08L62.341 5.113ZM39.437 55.5h-6.005l2.595 11.786 3.41-11.786Z",
  fill: "#C74800"
})));

export default SvgRage;